import StopStatusLogStage from './styled';

export default StopStatusLogStage;
